import React from "react";

import { connect } from "../i18n/connect";
import useInvoices from "../hooks/useInvoices";

export default function withInvoices(WrappedComponent) {
  const mapStateToProps = () => ({});

  function WithInvoicesComponent(props) {
    const { ...rest } = useInvoices();

    return <WrappedComponent {...props} {...rest} />;
  }

  return connect(mapStateToProps)(WithInvoicesComponent);
}
